import Repository from './Repository'

const resource = '/twilio'

export default {
  get () {
    return Repository.get(`${resource}`)
  },
  async getList (companyId = null) {
    try {
      return await Repository.get(`${resource}/get-activities${companyId ? '/' + companyId : ''}`)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  setErrors (e) {
    console.log('error: ', e)
    const errorCode = e.response ? e.response.status : 500
    return {
      status: false,
      errorCode: errorCode,
      data: e.response ? e.response.data : 'error',
      error: e
    }
  },
  catchError (e) {
    return e.response ? e.response.data : 'error'
  }
}
